import React from "react";
// also exported from '@storybook/react' if you can deal with breaking changes in 6.1
import { GreaterThanExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/GreaterThan";

import { DataDefinition } from "../../../rule-engine-core/Common/Data/DataDefinition";

import { NumberDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";

import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";

import { XExecutableTester } from "../XExecutableTester";

import { TreeRuleConfiguration } from "../../../rule-engine-core/Rule/Tree/TreeRuleConfiguration";
import { BooleanDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { getIfElseSimpleRule } from "../../../Expressions/Testing/LogicData";
import { StoryNode } from "../../StoryBook/StoryData";

function factory() {
    let treeRule = new TreeRuleConfiguration();
    let datadef = new DataDefinition();
    let age = new NumberDataDefinition("age");
    age.allowDecimals = false;
    datadef.fields.push(age);
    datadef.fields.push(new NumberDataDefinition("income"));

    treeRule.inputData = () => {
        return datadef;
    };

    let odatadef = new StringDataDefinition();

    treeRule.executionResult = odatadef;

    treeRule.root.setupEvaluation(datadef);

    let greaterThan = new GreaterThanExpression();
    greaterThan.value1.variableName = "age";
    greaterThan.value2.value = 18;

    treeRule.root.expression.expression = greaterThan;

    treeRule.root.falseNode!.setupResult(datadef, odatadef);
    treeRule.root.falseNode!.expression.value = "Nonage";

    treeRule.root.trueNode!.setupEvaluation(datadef);

    greaterThan = new GreaterThanExpression();
    greaterThan.value1.variableName = "income";
    greaterThan.value2.value = 5000;

    treeRule.root.trueNode!.expression.expression = greaterThan;

    treeRule.root.trueNode!.falseNode!.setupResult(datadef, odatadef);
    treeRule.root.trueNode!.falseNode!.expression.value = "Begineer";
    treeRule.root.trueNode!.trueNode!.setupResult(datadef, odatadef);
    treeRule.root.trueNode!.trueNode!.expression.value = "Senior";

    return treeRule;
}

export const TreeRuleTester = [
    new StoryNode(
        () => {
            return <XExecutableTester executable={factory()} />;
        },
        "Shared",
        "Tester",
        "Tree Rule",
        "Default",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = factory();

            let datadef = new DataDefinition();
            let age = new NumberDataDefinition("age");
            age.allowDecimals = false;
            datadef.fields.push(age);
            datadef.fields.push(new NumberDataDefinition("income"));
            datadef.fields.push(new BooleanDataDefinition("isEmployee"));
            datadef.fields.push(new BooleanDataDefinition("isContractor"));

            ruleDefinition.inputData = () => datadef;

            ruleDefinition.root.trueNode!.trueNode!.setupEvaluation(ruleDefinition.getInputDefinition());
            ruleDefinition.root.trueNode!.trueNode!.expression.expression = getIfElseSimpleRule().expression;

            return <XExecutableTester executable={ruleDefinition} />;
        },
        "Shared",
        "Tester",
        "Tree Rule",
        "If Then",
    ),
];
